module.exports = __webpack_public_path__ + "assets/img/first.ef71e372.png";